<template>
  <div class="footer">
    <div class="footer-inner">
      <div class="footer-main">
        <div class="footer-left">
          <a href="http://www.icost.ac.cn" target="_blank">
            <img :src="mapImg" alt="地图" />
          </a>
        </div>
        <div class="footer-center">
          <div class="info-row">
            <span class="info-item"><i class="el-icon-location-outline" />地址：广州市黄埔区开源大道136号B2栋</span>
            <span class="info-item"><i class="el-icon-postcard" />邮编：510530</span>
          </div>
          <div class="info-row">
            <span class="info-item"><i class="el-icon-message" />邮箱：zmzhang@icost.ac.cn</span>
            <span class="info-item"><i class="el-icon-phone-outline" />电话：15040321308</span>
            <span class="info-item"><i class="el-icon-printer" />传真：020-22309459</span>
          </div>
        </div>
        <div class="footer-right">
          <div class="qr-code">
            <img :src="qrcode1" alt="官方微信" />
            <p>官方微信</p>
          </div>
          <div class="qr-code">
            <img :src="qrcode2" alt="检测中心" />
            <p>检测中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      版权所有 广东腐蚀科学与技术创新研究院 备案号：
      <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2020142395号-4</a>
    </div>
  </div>
</template>

<script>
import mapImg from '@/assets/img/di_tu1.png'
import qrcode1 from '@/assets/img/cot7.png'
import qrcode2 from '@/assets/img/cot8.png'

export default {
  name: 'FooterComp',
  data () {
    return {
      mapImg,
      qrcode1,
      qrcode2
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: #1080bf;
  color: #fff;
  margin-top: auto;

  .footer-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px 15px 20px;
  }

  .footer-main {
    display: flex;
    align-items: flex-start;
    gap: 30px;

    .footer-left {
      flex-shrink: 0;
      img {
        width: 384px;
        border-radius: 4px;
      }
    }

    .footer-center {
      flex: 1;

      .info-row {
        display: flex;
        flex-wrap: wrap;
        gap: 12px 40px;
        margin: 10px 0;
      }

      .info-item {
        display: inline-flex;
        align-items: center;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1.8;

        i {
          margin-right: 6px;
          font-size: 16px;
        }
      }
    }

    .footer-right {
      display: flex;
      gap: 20px;
      flex-shrink: 0;

      .qr-code {
        text-align: center;
        img {
          width: 90px;
          height: 90px;
          border-radius: 4px;
        }
        p {
          margin: 6px 0 0;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.75);
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding: 15px;
    font-size: 13px;
    // color: rgba(255, 255, 255, 0.6);
    background: #004898;

    a {
      color: #fff;
      text-decoration: none;
      &:hover {
        color: #fff;
      }
    }
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .footer {
    .footer-main {
      flex-direction: column;
      align-items: center;
      text-align: center;

      .footer-center .info-row {
        justify-content: center;
      }

      .footer-right {
        justify-content: center;
      }
    }
  }
}
</style>
